<template>
  <div
    id="data-list-list-view"
    class="data-list-container vs-con-loading__container">
    <VehicleShipmentForm
      :addNewData="openModal"
      @closeModal="closeModalForm()"
      :title="modalTitle"
      :editMode="editMode"
      :dataEdit="dataEdit" />

    <div class="flex flex-wrap-reverse items-center">
      <!-- ADD NEW -->
      <div
        class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary"
        @click="openModalForm()">
        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
        <span class="ml-2 text-base text-primary">Add New</span>
      </div>
    </div>

    <vs-table ref="table" :max-items="itemsPerPage" :data="dataVehicleShipments">
      <template
        #header
        class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <!-- ITEMS PER PAGE -->
      </template>
      <template #thead>
        <vs-th sort-key="license_plate">License Plate</vs-th>
        <vs-th sort-key="license_plate">Shipment No</vs-th>
        <vs-th sort-key="license_plate">Send Status</vs-th>
        <vs-th sort-key="license_plate">Action</vs-th>
      </template>
      <template v-slot="{ data }">
        <tbody id="isi_table">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in dataVehicleShipments">
            <vs-td>{{ tr.license_plate }}</vs-td>
            <vs-td>{{ tr.shipment_no }}</vs-td>
            <vs-td>
              <p>{{ tr.send_status ? "Send":"Not Send" }}</p>
            </vs-td>
            <vs-td class="w-1">
              <div class="flex justify-between">
                <vs-button
                  @click="editVehicleShipment(tr.id)"
                  color="warning"
                  class="mr-2">
                  Edit
                </vs-button>
                <vs-button
                  @click="deleteVehicleShipment(tr.id)"
                  color="danger"
                  class="mr-2">
                  Delete
                </vs-button>
              </div>
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>

    <template v-if="refresh">
      <vs-pagination :total="last_page" v-model="page"></vs-pagination>
    </template>
  </div>
</template>

<script>
import * as REPO from '../../../repository/index'
import VehicleShipmentForm from './VehicleShipmentForm.vue'

export default {
  components: {
    VehicleShipmentForm,
  },
  data() {
    return {
      refresh: true,
      openModal: false,
      editMode: false,
      dataEdit: {},
      dataVehicleShipments: [],
      page: 1,
      itemsPerPage: 10,
      last_page: 0,
    }
  },
  computed: {
    modalTitle() {
      return this.editMode ? 'Update Vehicle Shipment' : 'Add Vehicle Shipment'
    },
  },
  watch: {
    page(val) {
      this.refresh = true
      this.getVehicleShipment({ page: val })

    },
  },
  created() {
    this.getVehicleShipment()
  },
  methods: {
    openModalForm() {
      this.editMode = false
      this.dataEdit = {}
      this.openModal = true
    },
    closeModalForm() {
      this.openModal = false
      this.editMode = false
      this.getVehicleShipment()
    },
    getVehicleShipment(body) {
      REPO.getListVehicleShipment(body)
        .then((res) => {
          const responseData = res && res.data && res.data.data ? res.data.data : {}
          this.dataVehicleShipments = responseData.data || []
          this.last_page = responseData.last_page || 0
          this.itemsPerPage = responseData.per_page || this.itemsPerPage
          this.page = responseData.current_page || this.page
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error',
            text: 'Failed to load vehicle shipment data',
            color: 'danger',
            position: 'top-right',
          })
        })
    },
    getDetailVehicleShipment() {},
    storeVehicleShipment() {},
    editVehicleShipment(id) {
      this.editMode = true
      this.openModal = true
      REPO.getDetailVehicleShipment(id).then((res) => {
        this.dataEdit = res.data.data
      })
    },
    deleteVehicleShipment(id) {
      REPO.deleteVehicleShipment(id)
        .then(() => {
          this.getVehicleShipment()
          this.$vs.notify({
            title: 'Success',
            text: 'Data has been deleted',
            color: 'success',
            position: 'top-right',
          })
        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error',
            text: 'Failed to delete vehicle shipment',
            color: 'danger',
            position: 'top-right',
          })
        })

    },
  },
}
</script>
